import React from 'react';
import styled from 'styled-components';
import { AdfNodeProps } from './AdfModelTypes';

const Span = styled.span`
    display: inline-block;
    position: relative;

    padding: 0 .125rem;

    &:before {
        z-index: -1;
        content: '';
        position: absolute;
        inset: 0;
        background: #0515240F;
        border-radius: .25rem;
    }
`;

const trimAtFromStart = (str: string) => {
    if (str?.startsWith('@')) {
        return str.slice(1);
    }
    return str;
};

export const AdfMention = React.memo(({ node }: AdfNodeProps) => {
    return <Span>{trimAtFromStart(node.attrs?.text)}</Span>;
});
